import { twMerge } from "tailwind-merge";
import { Card, CardContent, CardHeader, H3, H5 } from "@sellar-io/components";
import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { SpinnerLegacy } from "../../../components";
import { InfiniteLoadingButton } from "../../../components/infiniteLoading/InfiniteLoadingButton";
import {
  TableLegacy,
  TableLegacyContainer,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTBody,
  TableLegacyTD,
} from "../../../components/table/TableLegacy";
import { useProductList } from "../../../hooks/api/v2/product/useProductList";

import { DiscountedPrice } from "../../stockList/DiscountedPrice";

export const BusinessConnectionProductsCard = ({
  connection,
}: {
  connection: SupplierRelationshipGetResponseType;
}) => {
  const productListQuery = useProductList(
    {
      query: [
        {
          type: "ParentId",
          modifier: "NOT_NULL",
        },
        {
          type: "showAllProducts",
          modifier: "EQUALS",
          value: false,
        },
      ],
      sortBy: "name",
      sortDir: "asc",
      limit: 10,
    },
    {
      RetailerId: connection.BuyerId ?? 0,
    },
  );

  return (
    <Card className="bg-white">
      <CardHeader
        className={twMerge("bg-white", "flex items-center justify-between")}
      >
        <H3>Products</H3>
      </CardHeader>
      <CardContent>
        {productListQuery.isPending ? (
          <SpinnerLegacy />
        ) : productListQuery.isError ? (
          <div>Something went wrong</div>
        ) : (
          <>
            {connection.AvailabilityTier?.name && (
              <div className="mb-6">
                <H5>Product catalogue</H5>
                <span>{connection.AvailabilityTier.name}</span>
              </div>
            )}
            <TableLegacyContainer>
              <TableLegacy>
                <TableLegacyTHead>
                  <TableLegacyTR>
                    <TableLegacyTH>Product item</TableLegacyTH>
                    <TableLegacyTH>Price (ex. VAT)</TableLegacyTH>
                  </TableLegacyTR>
                </TableLegacyTHead>
                <TableLegacyTBody>
                  {productListQuery.data.pages.map((page) =>
                    page.map((product) => (
                      <TableLegacyTR key={product.id}>
                        <TableLegacyTD>{product.name}</TableLegacyTD>
                        <TableLegacyTD>
                          <DiscountedPrice
                            productPriceTier={product.ProductPriceTier}
                          />
                        </TableLegacyTD>
                      </TableLegacyTR>
                    )),
                  )}
                </TableLegacyTBody>
              </TableLegacy>
            </TableLegacyContainer>{" "}
            <InfiniteLoadingButton query={productListQuery} />
          </>
        )}
      </CardContent>
    </Card>
  );
};
